import { messages as couponMarketMessages } from '../views/scm/couponMarketLang'
import { messages as couponPropertyPoolManageMessages } from '../views/scm/couponPropertyPoolManageLang'
import { messages as couponRuleMessages } from '../views/scm/couponRuleLang'
import { messages as couponPropertyPoolDetailMessages } from '../views/scm/couponPropertyPoolDetailLang'
import { messages as couponPropertyUserManageMessages } from '../views/scm/couponPropertyUserManageLang'
import { messages as couponPropertyUserDetailMessages } from '../views/scm/couponPropertyUserDetailLang'
import { messages as integralConfigManageMessages } from '../views/scm/integralConfigManageLang'
import { messages as integralRuleMessages } from '../views/scm/integralRuleLang'
import { messages as integralGiftDetailManageMessages } from '../views/scm/integralGiftDetailManageLang'
import { messages as communityIntegralMessages } from '../views/scm/communityIntegralLang'
import { messages as goldMessages } from '../views/scm/goldLang'
import { messages as reserveCatalogManageMessages } from '../views/scm/reserveCatalogManageLang'
import { messages as reserveParamsManageMessages } from '../views/scm/reserveParamsManageLang'
import { messages as reserveDiningManageMessages } from '../views/scm/reserveDiningManageLang'
import { messages as reserveServiceManageMessages } from '../views/scm/reserveServiceManageLang'
import { messages as addReserveDiningMessages } from '../views/scm/addReserveDiningLang'
import { messages as editReserveDiningMessages } from '../views/scm/editReserveDiningLang'
import { messages as doDiningMessages } from '../views/scm/doDiningLang'
import { messages as addReserveServiceMessages } from '../views/scm/addReserveServiceLang'
import { messages as ownerDiningMessages } from '../views/scm/ownerDiningLang'
import { messages as editReserveServiceMessages } from '../views/scm/editReserveServiceLang'
import { messages as reserveOrderMessages } from '../views/scm/reserveOrderLang'
import { messages as reserveConfirmMessages } from '../views/scm/reserveConfirmLang'

export const messages = {
    en: {

        ...couponMarketMessages.en,
        ...couponPropertyPoolManageMessages.en,
        ...couponRuleMessages.en,
        ...couponPropertyPoolDetailMessages.en,
        ...couponPropertyUserManageMessages.en,
        ...couponPropertyUserDetailMessages.en,
        ...integralConfigManageMessages.en,
        ...integralRuleMessages.en,
        ...integralGiftDetailManageMessages.en,
        ...communityIntegralMessages.en,
        ...goldMessages.en,
        ...reserveCatalogManageMessages.en,
        ...reserveParamsManageMessages.en,
        ...reserveDiningManageMessages.en,
        ...reserveServiceManageMessages.en,
        ...addReserveDiningMessages.en,
        ...editReserveDiningMessages.en,
        ...doDiningMessages.en,
        ...addReserveServiceMessages.en,
        ...ownerDiningMessages.en,
        ...editReserveServiceMessages.en,
        ...reserveOrderMessages.en,
        ...reserveConfirmMessages.en,
    },  
    zh: {
        ...couponMarketMessages.zh,
        ...couponPropertyPoolManageMessages.zh,
        ...couponRuleMessages.zh,
        ...couponPropertyPoolDetailMessages.zh,
        ...couponPropertyUserManageMessages.zh,
        ...couponPropertyUserDetailMessages.zh,
        ...integralConfigManageMessages.zh,
        ...integralRuleMessages.zh,
        ...integralGiftDetailManageMessages.zh,
        ...communityIntegralMessages.zh,
        ...goldMessages.zh,
        ...reserveCatalogManageMessages.zh,
        ...reserveParamsManageMessages.zh,
        ...reserveDiningManageMessages.zh,
        ...reserveServiceManageMessages.zh,
        ...addReserveDiningMessages.zh,
        ...editReserveDiningMessages.zh,
        ...doDiningMessages.zh,
        ...addReserveServiceMessages.zh,
        ...ownerDiningMessages.zh,
        ...editReserveServiceMessages.zh,
        ...reserveOrderMessages.zh,
        ...reserveConfirmMessages.zh,
    }
}